export const getPeriodicity = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Diaria';
      break;
    case 1:
      name = 'Semanal';
      break;
    case 2:
      name = 'Mensual';
      break;
    case 3:
      name = 'Anual';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getType = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Numérico';
      break;
    case 1:
      name = 'Selector simple';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getEvaluationName = (evaluation) => {
    switch (evaluation) {
      case 1:
        return 'Correcto';
      case 2:
        return 'Incorrecto';
      default:
        return 'NA';
    }
};
